import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Card, Btn } from "@/components/UI";
import { useWidgetSize } from "@/components/WidgetReorder";

// Dashboard.jsx'ten taşındı (MetaERP liste önizleme widget'ı).
export function PreviewCard({ title, icon: Icon, to, rows, columns, testid, empty = "Kayıt yok" }) {
  // Size-aware row cap so small widgets don't overflow. Read from context so
  // parent WidgetWrapper's size flows in without a DOM-prop leak.
  const widgetSize = useWidgetSize();
  const rowCap = widgetSize === "S" ? 2 : widgetSize === "M" ? 3 : widgetSize === "L" ? 5 : 8;
  return (
    <Card className="p-4" data-testid={testid}>
      <div className="flex items-center justify-between mb-3 gap-2 min-w-0">
        <h3 className="text-sm font-semibold flex items-center gap-2 text-slate-800 dark:text-slate-100 min-w-0 truncate" style={{ fontFamily: "'Manrope', sans-serif" }}>
          <Icon size={14} className="text-indigo-600 dark:text-indigo-400 shrink-0" /> <span className="truncate">{title}</span>
        </h3>
        <Link to={to} className="shrink-0">
          <Btn size="sm" variant="secondary" data-testid={`${testid}-goto`}>Tümü <ArrowRight size={12}/></Btn>
        </Link>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700/50">
            <tr>{columns.map((c, i) => <th key={i} className="text-left px-2 py-1.5 font-semibold text-slate-500 dark:text-slate-400 uppercase text-[10px]">{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {(!rows || rows.length === 0) && <tr><td colSpan={columns.length} className="text-center py-6 text-slate-400">{empty}</td></tr>}
            {(rows || []).slice(0, rowCap).map((r, i) => (
              <tr key={r.id || i} className="border-b border-slate-100 dark:border-slate-700/40 hover:bg-slate-50/60 dark:hover:bg-slate-800/40">
                {columns.map((c, ci) => <td key={ci} className="px-2 py-1.5 text-slate-700 dark:text-slate-300 max-w-[220px] truncate">{c.render ? c.render(r) : r[c.key] || "—"}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows && rows.length > rowCap && (
        <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-1.5 text-center">
          +{rows.length - rowCap} kayıt daha — <Link to={to} className="underline">Tümünü Gör</Link>
        </div>
      )}
    </Card>
  );
}
